import chartBuilderBase from "./chartBuilderBase.js";
import chartDisplaySettings from "./chartDisplaySettings.js";
import KeyFigure from "../../models/keyFigure/KeyFigure.js";
import keyFigureValueFormatter from "../../models/keyFigure/rendering/keyFigureValueFormatter.js";

/**
 * Builds default Highcharts options http://api.highcharts.com/highcharts
 *
 * @param {object} spec - Parameter object
 * @param {object} my - protected fields holder
 * @return {{}}
 */
function optionsBuilder(spec, my) {
	spec ||= {};
	my ||= {};

	const chartOptions = {
		className: "business-chart",
		margin: [0, 0, 70, 0],
		plotBackgroundColor: chartDisplaySettings.backgroundColor,
		pinchType: "",
		spacingBottom: 0,
		type: "column",
		zoomType: "",
		printWidth: 835, // guessed printed page width, works fine with our margins
	};

	const tooltipOptions = {
		valueSuffix: " SEK",
		valueDecimals: 0,
		followPointer: false,
		followTouchMove: false,
		style: { fontSize: "12px" },
	};

	const creditsOptions = {
		enabled: false,
	};

	const builderSpec = Object.create(spec);

	builderSpec.options = chartBuilderBase.mergeOptions(
		builderSpec.options || {},
		{
			chart: chartOptions,
			tooltip: tooltipOptions,
			credits: creditsOptions,
			title: null,
			legend: {
				enabled: false,
			},
		},
	);

	const that = chartBuilderBase(builderSpec, my);
	my.myself = that;

	return that;
}

optionsBuilder.sharedTooltipFormatter = function (pointFormatter) {
	return function () {
		let tooltip = `<b>${this.point.period.toSmartString()}</b><br/>`;
		const x = this.x.valueOf();

		// Since `shared` is incompatible with `stickyTracking = false` (for obvious reasons)
		// so I have to find all the points by myself,
		// that's why it's a bit more complicated here
		const points = this.series.chart.series.map((series) => {
			if (!series.visible) {
				return undefined;
			}
			return series.data.find((data) => data.x.valueOf() === x);
		});

		tooltip += points.map(pointFormatter).join("<br/>");

		return tooltip;
	};
};

optionsBuilder.keyFigureTooltipFormatter = function () {
	return optionsBuilder.sharedTooltipFormatter((point) => {
		if (point === undefined) {
			return "";
		}

		if (!point.series.options.keyFigure) {
			return "";
		}

		const keyFigure = new KeyFigure(point.series.options.keyFigure);
		const formatter = keyFigureValueFormatter.formatterFor(keyFigure);
		return `${keyFigure.getName()}: ${formatter(point.y)}`;
	});
};

export default optionsBuilder;
